import {merge} from 'lodash';
import environmentDefaults from 'src/environments/environment.defaults';
import {InvestmentStrategyName} from 'src/app/domain/model/investment-strategy/investment-strategy.model';

const APP_ENV = 'demo-caser';

export const environment = merge(environmentDefaults, {
  env: APP_ENV,
  rollbar: {
    environment: APP_ENV
  },
  recaptchaSiteKey: '6LcQbnwqAAAAADfxPRnBXop6_4TnTq69TF7GyKAW',
  requireRecaptcha: true,
  production: false,
  allowSecondContract: true,
  hostName: 'demo.caser.app.finizensdev.com',
  apiHost: 'https://caser-demo.api.finizens.com',
  langs: ['es'],
  partner: {
    id: 'caser',
    isExternal: true,
    appName: 'Demo Ahorrobot',
    name: 'Caser',
    webUrl: null,
    investmentPlan: {
      amountToBePremium: 100000
    },
    onlyCommercialization: false,
    canFinizensSuggestOptimizationRecommendations: true,
    providesIbanData: false,
    login: {
      provider: 'internal',
      type: 'user/password'
    },
    faqs: {
      url: 'https://www.caser.es/seguros-ahorro-inversion/ahorrobot',
    },
    contact: {
      phone: {
        countryPrefix: '0034',
        phoneNumber: '919100004',
        openingSchedule: {
          openingTime: '10:00',
          closingTime: '14:00',
          fromWeekday: 'monday',
          toWeekday: 'friday',
          includesLegalHolidays: false
        },
        callFromAbroad: false
      },
      email: 'ayuda@ahorrobotmail.caser.es'
    },
    kycPotentialAmountQuestions: false,
    partnerProvidesUserData: false,
    informedSale: false
  },
  fixtures: {
    enabled: true,
    externalLogin: {
      port: null
    }
  },
  analytics: {
    segmentWriteKey: 'GLUh3ljkJansrzagYtZZUJSMPxadMhYT',
    gtmId: null
  },
  affiliates: {
    financeAds: {
      enable: false
    },
    facebookPixel: {
      enable: false
    }
  },
  legal: {
    privacyPolicyUrl: 'https://www.caser.es/politica-de-privacidad',
    legalWarningUrl: 'https://www.caser.es/seguros-ahorro-inversion/ahorrobot',
  },
  layout: {
    showFooter: false,
    showHereWeExplainItInDetail: true,
    showLink: false,
    showPoweredBy: true,
    showLogout: true,
    footer: {
      show: true,
      type: 'tiny'
    },
  },
  products: {
    investment: null,
    pensionPlan: null,
    unitLinked: {
      defaultStrategy: InvestmentStrategyName.global,
      name: 'Ahorrobot',
      productId: 'ahorrobot_caser_unit_linked',
      isManagedInThisEnvironment: true,
      amount: {
        default: {
          minInitial: 50,
          maxInitial: 10000000,
          minMonthly: 50,
          maxMonthly: 1000000,
          recommendedInitial: 5000,
          recommendedExtraordinary: 5000,
          recommendedMonthly: 300,
          insuranceBenefitAmount: 500,
        }
      },
      custodians: {
        name: 'Caser Seguros',
        default: {
          deposit: {
            canDisableMonthly: true,
            minimumAmount: 50,
            annualMaximum: 12000000 // Máximo anual de un UL, basado en que se permiten aportaciones de 1.000.00€ al mes
          }
        }
      }
    },
  },
  fees: {
    feeReduction: 0.14
  },
  shareScreen: {
    enable: false,
    groupid: null,
    site: null
  },
  welcomeUrl: null,
  allowedPhonePrefixes: [
    {country: 'Alemania', prefix: '49'},
    {country: 'Andorra', prefix: '376'},
    {country: 'Argentina', prefix: '54'},
    {country: 'Australia', prefix: '61'},
    {country: 'Austria', prefix: '43'},
    {country: 'B\u00e9lgica', prefix: '32'},
    {country: 'Brasil', prefix: '55'},
    {country: 'Bulgaria', prefix: '359'},
    {country: 'Canad\u00e1', prefix: '1'},
    {country: 'Chile', prefix: '56'},
    {country: 'Corea del Sur', prefix: '82'},
    {country: 'Costa Rica', prefix: '506'},
    {country: 'Croacia', prefix: '385'},
    {country: 'Dinamarca', prefix: '45'},
    {country: 'Ecuador', prefix: '593'},
    {country: 'Rep\u00fablica Eslovaca', prefix: '421'},
    {country: 'Eslovenia', prefix: '386'},
    {country: 'Espa\u00f1a', prefix: '34'},
    {country: 'Estados Unidos', prefix: '1'},
    {country: 'Estonia', prefix: '372'},
    {country: 'Finlandia', prefix: '358'},
    {country: 'Francia', prefix: '33'},
    {country: 'Georgia', prefix: '995'},
    {country: 'Grecia', prefix: '30'},
    {country: 'Groenlandia', prefix: '299'},
    {country: 'Honduras', prefix: '504'},
    {country: 'Hong Kong', prefix: '852'},
    {country: 'Hungr\u00eda', prefix: '36'},
    {country: 'India', prefix: '91'},
    {country: 'Irlanda', prefix: '353'},
    {country: 'Isla de Navidad', prefix: '61'},
    {country: 'Isla de Norfolk', prefix: '672'},
    {country: 'Islandia', prefix: '354'},
    {country: 'Islas Cocos o Islas Keeling', prefix: '61'},
    {country: 'Islas de Aland', prefix: '358'},
    {country: 'Islas Faroe', prefix: '298'},
    {country: 'Islas Georgias del Sur y Sandwich del Sur', prefix: '500'},
    {country: 'Islas Ultramarinas Menores de Estados Unidos', prefix: '246'},
    {country: 'Italia', prefix: '39'},
    {country: 'Jap\u00f3n', prefix: '81'},
    {country: 'Letonia', prefix: '371'},
    {country: 'Lituania', prefix: '370'},
    {country: 'Macedonia', prefix: '389'},
    {country: 'Malasia', prefix: '60'},
    {country: 'Mayotte', prefix: '262'},
    {country: 'M\u00e9xico', prefix: '52'},
    {country: 'Moldavia', prefix: '373'},
    {country: 'Montenegro', prefix: '382'},
    {country: 'Noruega', prefix: '47'},
    {country: 'Nueva Caledonia', prefix: '687'},
    {country: 'Nueva Zelanda', prefix: '64'},
    {country: 'Pa\u00edses Bajos', prefix: '31'},
    {country: 'Paraguay', prefix: '595'},
    {country: 'Polinesia Francesa', prefix: '689'},
    {country: 'Polonia', prefix: '48'},
    {country: 'Portugal', prefix: '351'},
    {country: 'Puerto Rico', prefix: '1'},
    {country: 'Reino Unido', prefix: '44'},
    {country: 'Chequia', prefix: '420'},
    {country: 'Rep\u00fablica Dominicana', prefix: '1809'},
    {country: 'San Bartolom\u00e9', prefix: '590'},
    {country: 'San Pedro y Miquel\u00f3n', prefix: '508'},
    {country: 'Rep\u00fablica de Sud\u00e1frica', prefix: '27'},
    {country: 'Suecia', prefix: '46'},
    {country: 'Suiza', prefix: '41'},
    {country: 'Islas Svalbard y Jan Mayen', prefix: '47'},
    {country: 'Territorio Brit\u00e1nico del Oc\u00e9ano \u00cdndico', prefix: '246'},
    {country: 'Tierras Australes y Ant\u00e1rticas Francesas', prefix: '33'},
    {country: 'Islas Tokelau', prefix: '690'},
    {country: 'Uruguay', prefix: '598'}
  ],
  defaultSimulatorTolerance: 3,
  features: {
    jointHolder: false
  }
});
